export default class HotspotResponseMapper {
  map(response: any) {
    return response;
  }

  unMap(response: any) {
    return response;
  }
}
